import { createApp } from "vue";
import App from "./App.vue";
// import { createI18n } from "vue-i18n";
import {
  createVueI18n,
  changeLanguageVue,
} from "@popfex/i18n-translate/adapters/vue";

import { en, zhHans, zhHant} from "../locale/index.js";
import "./styles/variety-font/index.js";
import { getStorage, setStorage } from "@/utils/storage";
import { countryToLanguage, countryToCountry } from "@/utils/common.js";
import Antd from "ant-design-vue";
import Vconsole from "vconsole";
import "ant-design-vue/dist/reset.css";
import Cookies from "js-cookie";
import init from "@/utils/hybrid/init";
import { isPopApp } from "@/utils/hybrid";
import "@/utils/flexiable.js";

if (isPopApp()) {
  init();
}

const messages = {
  en,
  zh: zhHans,
  cht: zhHant,
};
const { pathname, origin, hash } = window.location;
const country = pathname.replaceAll("/", "") || "us";

// pathname转为小写后重新刷新下页面
const currentPathname = pathname;
const lowerCasePathname = currentPathname.toLowerCase();
// 如果当前pathname包含大写字母，则重定向到小写版本
if (currentPathname !== lowerCasePathname) {
  const newUrl = origin + lowerCasePathname + hash;
  window.location.replace(newUrl);
}

const app = createApp(App);

let localesFolder = "locales";
let locale = getStorage("LANGUAGE") || countryToLanguage(country);

if (locale === "zh-TW" || locale === "zh-HK") {
  locale = "cht";
} else if (locale === "zh-CN") {
  locale = "zh";
}

// 测试环境使用vconsole和测试语言包
if (process.env.DEFINE_NODE_ENV !== "prod") {
  const vConsole = new Vconsole();
  app.use(vConsole);
  localesFolder = "locales-test";
}

let i18nConfig = {
  defaultLang: locale,
  localMessages: messages,
  remoteBaseUrl: "https://gss-vs-client-gcs.popmart.com/data/" + localesFolder,
  fallbackLocale: "en",
  supportedLngs: ["zh", "en", "kor", "cht", "jp", "id", "spa", "ara", 'th'],
  cacheTTL: 1 * 60 * 1000, // 1分钟
};
const i18n = await createVueI18n(i18nConfig);
let direction = "ltr";

if (["ara"].includes(locale)) {
  direction = "rtl";
  document.documentElement.dir = "rtl";
} else {
  document.documentElement.dir = "ltr";
}
//direction挂在全局上
app.config.globalProperties.$direction = direction;

setStorage("LANGUAGE", locale);
setStorage("countryStorage", countryToCountry(country || "us"));

window.i18n = i18n;

app.use(i18n);
app.use(Antd);
app.mount("#app");
